import { Box, Button, Stack, useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';

interface DealSetupFooterProps {
  onCancel: () => void;
  onSave: () => void;
  isSubmitEnabled: boolean;
  dealUpdatedDetailsComponent: JSX.Element;
}
const DealSetupFooter: FC<DealSetupFooterProps> = (props) => {
  const { onCancel, onSave, isSubmitEnabled, dealUpdatedDetailsComponent } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      sx={{
        flex: 0,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        pt: '1rem',
        gap: '1rem',
        ...(isMobile ? { pb: '2.5rem' } : {}),
        borderTop: '1px solid #E8EAEB',
      }}
    >
      <Box>{dealUpdatedDetailsComponent}</Box>
      <Stack direction={'row'} justifyContent={'flex-end'} gap={'0.5rem'} py={'0.5rem'}>
        <Button
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
          variant="outlined"
          onClick={onCancel}
          sx={{
            borderRadius: '2rem',
            padding: '0.625rem 1.5rem',
            alignItems: 'center',
            textTransform: 'none',
            color: '#2F736E',
          }}
        >
          Cancel
        </Button>

        <Button
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
          sx={{
            borderRadius: '2rem',
            backgroundColor: '#2F736E',
            color: '#fff',
            padding: '0.625rem 1.5rem',
            alignItems: 'center',
            textTransform: 'none',
          }}
          disabled={!isSubmitEnabled}
          onClick={onSave}
          variant="contained"
        >
          Save
        </Button>
      </Stack>
    </Box>
  );
};

export default DealSetupFooter;
